import { createFileRoute } from "@tanstack/react-router";
import { ScreenPage } from "@/components/dashboard/screen-page";
export const Route = createFileRoute("/mailing")({
 head:()=>({meta:[{title:"Mailing — Deuxda Admin"},{name:"description",content:"Create targeted email campaigns and measure delivery."},{property:"og:title",content:"Mailing — Deuxda Admin"},{property:"og:description",content:"Create targeted email campaigns and measure delivery."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component:()=> <ScreenPage screen="mailing"/>,
});
